import dynamic from 'next/dynamic';
import { AbandonCartModalProps } from './AbandonCartModal.types';
export type { AbandonCartModalProps } from './AbandonCartModal.types';

export const AbandonCartModal = dynamic<AbandonCartModalProps>(() =>
  import('./AbandonCartModal').then(module => module.AbandonCartModal)
);
